import React,{ useState, useEffect,useCallback, useRef } from 'react'
import MainCard from '../ui-component/cards/MainCard'
import UserDetailsCard from '../ui-component/cards/UserDetailsCard'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import axios from 'axios'
import Loading from '../../../caller-components/Loading';
import Pagination from '../generic-components/Pagination';
import _ from 'lodash';
import "../../../main.css";
import Selectedrow from '../generic-components/Selectedrow';
import DataTable from '../generic-components/SecondDataTable';
import TextField from '@mui/material/TextField';
import MenuIcon from '@mui/icons-material/Menu';
import AppsIcon from '@mui/icons-material/Apps';
import { useDispatch } from 'react-redux';
import * as actionTypes from '../store/actions';
import CircularProgress from '@mui/material/CircularProgress';
import { FormattedMessage } from 'react-intl';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import CloseIcon from '@mui/icons-material/Close';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useLocation } from 'react-router-dom';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const SearchPage = () => {
  const [firstLetter] = useState(["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "R", "S", "T", "U", "V", "Y", "Z", "W"]);
  const [patientData, setPatientData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(7);
  const [postPerPageTable, setPostPerPageTable] = useState(7);
  const [selectRow] = useState("");
  const [switchTable, setSwitchTable] = useState(false);
  const [takenData, setTakenData] = useState([]);
  const [value, setValue] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [filters, setFilters] = useState({
    order_by: "created",
    sorting_method: "forward",
    filtered_status: []
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [caseCount, setCaseCount] = useState(0);
  const location = useLocation();

  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  const indexOfLastPostTable = currentPage * postPerPageTable;
  const indexOfFirstPostTable = indexOfLastPostTable - postPerPageTable;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get('search');
    
    if (searchQuery) {
      setValue(searchQuery);
      fetchSearchResults(searchQuery);
    }
  }, [location]);

  const fetchSearchResults = useCallback(async (searchValue) => {
    if (searchValue.length > 2) {
      setLoading(true);
      try {
        const response = await axios.get(`/orthero-api/v2/anatecsearch/?search=${searchValue}`);
        setPatientData(response.data);
        setPageCount(0);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    } else {
      setPatientData(takenData.results || []);
      setPageCount(takenData.page_count || 0);
    }
    setCurrentPage(1);
  }, [takenData]);

  const debouncedFetchSearchResults = useCallback(_.debounce(fetchSearchResults, 2000), [fetchSearchResults]);

  const handleChange = (e) => {
    setValue(e.target.value);
    debouncedFetchSearchResults(e.target.value);
  };

  const handlePaginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowSelect = (e) => {
    setPostPerPageTable(e.target.value);
  };

  const switchTableHandler = (value) => {
    setSwitchTable(value);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      {!loading ? (
        <React.Fragment>
          <Grid display="flex" alignItems="center" flexWrap="wrap" justifyContent="space-between">
            <Grid display="flex" gap="1rem" flexWrap="wrap" alignItems="center">
              <Box sx={{ width: 500 }}>
                <TextField
                  value={value}
                  onChange={handleChange}
                  fullWidth
                  label={<FormattedMessage id="Search Patient" />}
                  id="fullWidth"
                />
              </Box>
            </Grid>
            <Grid display="flex" alignItems="center">
              <Box display="flex" alignItems="center" flexWrap="wrap" gap="0.5rem" paddingLeft={1}>
                <Grid
                  onClick={() => switchTableHandler(true)}
                  borderRadius={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  style={{
                    backgroundColor: switchTable ? "rgb(102, 59, 185)" : "inherit",
                    padding: "3px"
                  }}
                >
                  <MenuIcon style={{ cursor: 'pointer', color: switchTable ? "#EEE7F7" : "rgb(102, 59, 185)" }} />
                </Grid>
                <Grid
                  onClick={() => switchTableHandler(false)}
                  borderRadius={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  style={{
                    backgroundColor: !switchTable ? "rgb(102, 59, 185)" : "inherit",
                    padding: "3px"
                  }}
                >
                  <AppsIcon style={{ cursor: 'pointer', color: !switchTable ? "#EEE7F7" : "rgb(102, 59, 185)" }} />
                </Grid>
              </Box>
            </Grid>
          </Grid>
          {!switchTable ? (
            <React.Fragment>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container>
                  {patientData.map(k => (
                    <Grid item lg={3} md={4} sm={6} xs={12} key={k.id}>
                      <Item style={{ backgroundColor: "inherit" }}>
                        <UserDetailsCard
                          processingData={k.processing}
                          processCount={k.process_count}
                          lowerCount={k.last_order.lower_count}
                          upperCount={k.last_order.upper_count}
                          photo={k.profil_pic}
                          createdDate={k.created}
                          planTag={k.last_order.case_plan_type}
                          planName={k.last_order.case_plan_name}
                          analysisPk={k.last_order.analysis_pk}
                          status={k.last_order.status}
                          sendStatus={k.last_order.status}
                          caseId={k.case_id}
                          isCancelled={k.cancelled}
                          casePk={k.id}
                          gender={k.patient_gender}
                          name={k.patient_name}
                          doctor={k.doctor_name}
                          lastName={k.patient_lastname}
                          jawType={k.confirmation_analysis.jaw_type}
                          analysisType={k.confirmation_analysis.analysis_type}
                        />
                      </Item>
                    </Grid>
                  ))}
                </Grid>
                <Pagination
                  pageCount={pageCount}
                  handlePaginate={handlePaginate}
                  currentPage={currentPage}
                  data={patientData}
                  postPerPage={postPerPage}
                />
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <MainCard style={{ marginTop: "12px" }}>
                <Box sx={{ width: '100%' }}>
                  <DataTable
                    data={patientData}
                    setData={setPatientData}
                    indexOfFirstPost={indexOfFirstPostTable}
                    indexOfLastPost={indexOfLastPostTable}
                  />
                  <div className="pagination-grid">
                    <Pagination
                      pageCount={pageCount}
                      handlePaginate={handlePaginate}
                      currentPage={currentPage}
                      data={patientData}
                      postPerPage={postPerPageTable}
                    />
                    <Selectedrow
                      postPerPage={postPerPageTable}
                      data={patientData}
                      dataValues={[7, 20, 30]}
                      handleRowSelect={handleRowSelect}
                      value={selectRow}
                    />
                  </div>
                </Box>
              </MainCard>
            </React.Fragment>
          )}
        </React.Fragment>
      ) : (
        <Grid display="flex" justifyContent="center" alignItems="center" mt={20}>
          <CircularProgress color="secondary" />
        </Grid>
      )}
    </div>
  );
};

export default SearchPage; 